import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "card py-2 px-2"
}
const _hoisted_3 = {
  key: 1,
  class: "card py-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_partner_seats = _resolveComponent("partner-seats")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Seat Management")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.seats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("table", null, [
                  _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "header-row py-2 px-2" }, "Partner Name"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Partner Slug"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Used Seats"),
                      _createElementVNode("th", { class: "header-row py-2" }, "Seat Total")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seats, (seat, index) => {
                      return (_openBlock(), _createElementBlock("tr", { key: index }, [
                        _createVNode(_component_partner_seats, { "partner-seats-obj": seat }, null, 8, ["partner-seats-obj"])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "text-center" }, "No data for Partner Seats was returned at this time.", -1)
              ])))
        ]))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}